
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  getProductMaterials,
  get3dPrintMaterials,
  getSeparateProduct,
} from "@pazion/pazion-catalog/src/services/catalog-service";
import { ICustomOrderLine } from "@pazion/pazion-catalog/src/models/order";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";

import FileUploader from "@pazion/pazion-core/src/components/common/FileUploader.vue";
import { ModelStl } from "vue-3d-model";

@Component({
  components: {
    PazTooltipButton,
    FileUploader,
    ModelStl,
    PazToast,
  },
})
export default class PazOrderDialog extends Vue {
  $refs!: {
    fileUploader: FileUploader;
    toast: PazToast;
  };

  @Prop({ default: false })
  public isEditable!: boolean;

  @Prop()
  public item: ICustomOrderLine | undefined;

  @Prop({ default: () => [] })
  public productCategories!: { title: string; value: string, image?:string }[];

  @Prop({ default: () => [] })
  public productOrientations!: { title: string; value: string }[];

  @Prop({ default: () => [] })
  public productExtras!: { title: string; value: string }[];

  @Prop({ default: "" })
  public type!: string;

  //in model: :lights="lights"
  // public lights=[
  //   {
  //     type: "AmbientLight",
  //     color: "white",
  //     intensity:0.8,
  //   },
  //   {
  //     type: "DirectionalLight",
  //     position: { x: 100, y: 10, z: 100 },
  //     color: "green",
  //     intensity: 0.8,
  //   },
  //   {
  //     type: "PointLight",
  //     color: "#000000",
  //     position: { x: 200, y: -200, z: 100 },
  //     intensity: 1
  //   },
  //   {
  //     type: "HemisphereLight",
  //     skyColor: "#00FF00",
  //     groundColor: "#000000",
  //     position: { x: 200, y: -200, z: 100 }
  //   }
  // ];

  public selectedProductCategory: string = "";
  public isLoading: boolean = false;
  public productMaterials: { title: string; value: string }[] = [];

  // example of possible data
  public selectedItem: ICustomOrderLine = {
    order: 0,
    productType: "",
    productMaterial: "",
    productOrientation: "",
    productExtra: "",
    notes: "",
    productFile: "",
    quantity: 1,
  };

  public product: { id: number | null } = { id: null };

  async fetchProductMaterials(value?: string) {
    if (!value) return;
    const productMaterial = await getProductMaterials(value);
    this.productMaterials = Object.entries(productMaterial.data).map(
      (entry: string[]) => {
        return { title: entry[1], value: entry[0] };
      }
    );
  }

  public isLoadingFile: boolean = false;

  onFileSelect(file: string) {
    this.isLoadingFile = true;
    this.selectedItem.productFile = file;
  }

  onFileClear() {
    this.selectedItem.productFile = "";
  }

  async dragFile(event: DragEvent) {
    if (!this.isEditable) return;
    if (event.dataTransfer.files.length > 1) {
      this.$refs.toast.show({
        message: "Only one stl file upload is allowed.",
        icon: "mdi-close-circle",
        color: "red",
      });
      return;
    }
    if (
      !event.dataTransfer.files[0].name.includes(".stl") &&
      !event.dataTransfer.files[0].type.includes("stl")
    ) {
      this.$refs.toast.show({
        message: "The file must have the .stl extension.",
        icon: "mdi-close-circle",
        color: "red",
      });
      return;
    }

    this.$refs.fileUploader.onUpload(event.dataTransfer.files[0]);
  }

  onLoad() {
    this.isLoadingFile = false;
  }

  handleAddOrderLine() {
    const item = this.isDefault
      ? { ...this.selectedItem, virtual: true }
      : { product: { ...this.product }, ...this.selectedItem };
    this.$emit("on-add-order-line", item);
  }

  handleRemoveOrderLine() {
    this.$emit("on-remove-order-line", this.selectedItem.id);
  }

  get isDefault() {
    const types = ["default", "virtual", "frezen"];
    if (this.item && this.item.lineType) {
      return types.includes(this.item.lineType);
    }
    return types.includes(this.type);
  }

  get is3dPrint() {
    if (this.item && this.item.lineType) {
      return this.item.lineType === "3dprint";
    }
    return this.type === "3dprint";
  }

  get isSeparateProduct() {
    if (this.item && this.item.lineType) {
      return this.item.lineType === "separate_product";
    }
    return this.type === "separate_product";
  }

  get isDisabledBtn() {
    if (!this.isDefault) {
      return this.product.id === null
    }
  }

  async mounted() {
    this.isLoading = true;
    if (this.item) {
      this.selectedItem = { ...this.item };
    }
    if (this.item && this.item?.product) {
      this.product.id = this.item.product;
      this.selectedItem.quantity = Number(this.selectedItem.quantity);
    }
    try {
      if (this.isDefault) {
        await this.fetchProductMaterials(this.selectedItem.productType);
      }

      if (this.is3dPrint) {
        const { data } = await get3dPrintMaterials();

        const items: any[] = [];
        Object.values(data).map((item) => {
          if (typeof item !== "string") {
            items.push(item);
          }
        });
        this.productMaterials = items.map((item) => {
          return { title: item.name, value: item.id };
        });
      }

      if (this.isSeparateProduct) {
        const { data } = await getSeparateProduct();

        const items: any[] = [];
        Object.values(data).map((item) => {
          if (typeof item !== "string") {
            items.push(item);
          }
        });
        this.productMaterials = items.map((item) => {
          return { title: item.name, value: item.id };
        });
      }
    } finally {
      this.isLoading = false;
    }
  }
} //
